import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['inputMethod', 'fileField', 'shipperField', 'consigneeField', 'notifyPartyField'];

  connect() {
    this.displayFields();
  }

  changeInputMethodHandler() {
    this.displayFields();
  }

  displayFields() {
    const inputMethodTarget = this.inputMethodTargets.find((target) => target.checked);
    this.hideAllFields();

    if (inputMethodTarget && inputMethodTarget.value === 'inputted') {
      this.shipperFieldTarget.classList.remove('hidden');
      this.consigneeFieldTarget.classList.remove('hidden');
      this.notifyPartyFieldTarget.classList.remove('hidden');
    } else if (inputMethodTarget && inputMethodTarget.value === 's_i_attached') {
      this.fileFieldTarget.classList.remove('hidden');
    }
  }

  hideAllFields() {
    this.fileFieldTarget.classList.add('hidden');
    this.shipperFieldTarget.classList.add('hidden');
    this.consigneeFieldTarget.classList.add('hidden');
    this.notifyPartyFieldTarget.classList.add('hidden');
  }
}
